import type { TranslationKey } from "./en";

export const ar: Record<TranslationKey, string> = {
  "app.name": "ريل إيه آي",
  "app.tagline": "فيديو قصير من صناعة الذكاء الاصطناعي، أقل من 60 ثانية.",

  "nav.feed": "المقاطع",
  "nav.upload": "رفع",
  "nav.mine": "مقاطعي",
  "nav.profile": "الملف الشخصي",
  "nav.admin": "المراجعة",
  "nav.login": "تسجيل الدخول",
  "nav.register": "إنشاء حساب",
  "nav.logout": "تسجيل الخروج",
  "nav.menu": "القائمة",

  "common.loading": "جارٍ التحميل",
  "common.retry": "إعادة المحاولة",
  "common.cancel": "إلغاء",
  "common.save": "حفظ",
  "common.saved": "تم الحفظ",
  "common.delete": "حذف",
  "common.close": "إغلاق",
  "common.edit": "تعديل",
  "common.more": "تحميل المزيد",
  "common.back": "رجوع",
  "common.optional": "اختياري",
  "common.copy": "نسخ الرابط",
  "common.copied": "تم نسخ الرابط",
  "common.theme": "تغيير المظهر",
  "common.language": "تغيير اللغة",
  "common.refresh": "تحديث",
  "common.of": "من",
  "common.characters": "حرفًا",
  "common.anonymous": "زائر",
  "common.empty": "لا يوجد شيء بعد",
  "common.notFound": "الصفحة غير موجودة",
  "common.notFoundHint": "الصفحة المطلوبة غير موجودة.",

  "auth.identifier": "اسم المستخدم أو البريد",
  "auth.password": "كلمة المرور",
  "auth.email": "البريد الإلكتروني",
  "auth.username": "اسم المستخدم",
  "auth.usernameHint": "من 3 إلى 32 حرفًا: أحرف لاتينية وأرقام وشرطة سفلية أو نقطة.",
  "auth.passwordHint": "10 أحرف على الأقل، وتجمع ثلاثة من: حرف صغير، حرف كبير، رقم، رمز.",
  "auth.loginTitle": "مرحبًا بعودتك",
  "auth.loginSubtitle": "سجّل الدخول لرفع المقاطع والتفاعل معها وإدارتها.",
  "auth.registerTitle": "أنشئ حسابك",
  "auth.registerSubtitle": "انشر مقاطع الذكاء الاصطناعي في أقل من دقيقة.",
  "auth.haveAccount": "لديك حساب بالفعل؟",
  "auth.noAccount": "لا تملك حسابًا؟",
  "auth.submitLogin": "تسجيل الدخول",
  "auth.submitRegister": "إنشاء الحساب",
  "auth.working": "يرجى الانتظار",
  "auth.strength.weak": "ضعيفة",
  "auth.strength.fair": "متوسطة",
  "auth.strength.strong": "قوية",
  "auth.registered": "تم إنشاء الحساب، وجارٍ تسجيل الدخول.",
  "auth.guestCta": "سجّل الدخول للمتابعة",
  "auth.guestHint": "هذا الإجراء يتطلب حسابًا.",
  "auth.sessions": "الجلسات النشطة",
  "auth.logoutEverywhere": "الخروج من كل الأجهزة",

  "feed.latest": "الأحدث",
  "feed.popular": "الأكثر مشاهدة",
  "feed.empty": "لا توجد مقاطع منشورة بعد.",
  "feed.emptyHint": "كن الأول: ارفع مقطعًا وانشره.",
  "feed.unmute": "تشغيل الصوت",
  "feed.mute": "كتم الصوت",
  "feed.play": "تشغيل",
  "feed.pause": "إيقاف",
  "feed.like": "إعجاب",
  "feed.unlike": "إزالة الإعجاب",
  "feed.report": "إبلاغ",
  "feed.share": "مشاركة",
  "feed.details": "التفاصيل",
  "feed.byAuthor": "مقاطع {name}",
  "feed.clearAuthor": "إزالة التصفية",
  "feed.scrollHint": "اسحب للمقطع التالي",

  "video.views": "مشاهدة",
  "video.likes": "إعجاب",
  "video.duration": "المدة",
  "video.resolution": "الأبعاد",
  "video.size": "الحجم",
  "video.status": "الحالة",
  "video.uploaded": "تاريخ الرفع",
  "video.published": "تاريخ النشر",
  "video.codec": "الترميز",
  "video.audio": "الصوت",
  "video.audioYes": "متوفر",
  "video.audioNo": "بدون صوت",
  "video.rejection": "سبب الرفض من المراجعة",
  "video.openReports": "بلاغات مفتوحة",
  "video.title": "العنوان",
  "video.description": "الوصف",
  "video.visible": "ظاهر في المقاطع",
  "video.hidden": "مخفي من المقاطع",
  "video.deleteConfirm": "حذف هذا المقطع؟",
  "video.deleteWarning": "سيُحذف الملف وإحصاءاته، ولا يمكن التراجع.",
  "video.unavailable": "هذا المقطع غير قابل للتشغيل بعد.",
  "video.pendingReview": "في انتظار المراجعة قبل الظهور في المقاطع.",

  "status.UPLOADING": "قيد الرفع",
  "status.VALIDATING": "قيد التحقق",
  "status.MODERATING": "قيد الفحص",
  "status.READY": "جاهز",
  "status.PUBLISHED": "منشور",
  "status.FLAGGED": "قيد المراجعة",
  "status.REJECTED": "مرفوض",
  "status.DELETED": "محذوف",

  "mine.title": "مقاطعي",
  "mine.subtitle": "كل ما رفعته، بكل الحالات.",
  "mine.empty": "لم ترفع أي مقطع بعد.",
  "mine.publish": "نشر",
  "mine.unpublish": "إلغاء النشر",

  "upload.title": "رفع مقطع",
  "upload.subtitle": "يُرسل الملف إلى التخزين مباشرة، ولا تمر بايتاته عبر الواجهة البرمجية.",
  "upload.drop": "اسحب الفيديو إلى هنا",
  "upload.dropHint": "بصيغة MP4، حتى {size} و{seconds} ثانية.",
  "upload.choose": "اختر ملفًا",
  "upload.replace": "اختر ملفًا آخر",
  "upload.titleLabel": "العنوان",
  "upload.titlePlaceholder": "اكتب عنوانًا للمقطع",
  "upload.descLabel": "الوصف",
  "upload.descPlaceholder": "أضف سياقًا أو الأمر النصي أو النموذج المستخدم",
  "upload.publishNow": "انشره تلقائيًا بعد اجتياز الفحص",
  "upload.submit": "بدء الرفع",
  "upload.cancel": "إلغاء الرفع",
  "upload.step.authorize": "التصريح",
  "upload.step.transfer": "النقل",
  "upload.step.confirm": "التأكيد",
  "upload.step.processing": "المعالجة",
  "upload.processing": "جارٍ التحقق من المقطع وفحصه",
  "upload.processingHint": "يستغرق ذلك ثوانٍ قليلة عادةً.",
  "upload.donePublished": "تم النشر، والمقطع ظاهر الآن.",
  "upload.doneFlagged": "أُوقف للمراجعة اليدوية.",
  "upload.doneRejected": "رُفض في مرحلة الفحص.",
  "upload.doneReady": "جاهز، وتستطيع نشره وقت ما تريد.",
  "upload.another": "رفع مقطع آخر",
  "upload.viewVideo": "فتح المقطع",
  "upload.errTooLarge": "حجم الملف {actual}، والحد الأقصى {limit}.",
  "upload.errTooLong": "مدة المقطع {actual} ثانية، والحد الأقصى {limit} ثانية.",
  "upload.errType": "لا يُقبل إلا فيديو MP4.",
  "upload.errProbe": "لم يتمكن المتصفح من قراءة الملف كفيديو.",
  "upload.requirements": "الشروط",

  "report.title": "الإبلاغ عن المقطع",
  "report.subtitle": "يراجع فريقنا كل بلاغ.",
  "report.reason": "السبب",
  "report.detail": "هل هناك تفاصيل أخرى؟",
  "report.submit": "إرسال البلاغ",
  "report.done": "شكرًا لك، تم تسجيل البلاغ.",
  "report.reason.sexual_content": "محتوى جنسي",
  "report.reason.violence": "عنف",
  "report.reason.hate_speech": "خطاب كراهية",
  "report.reason.illegal_activity": "نشاط غير قانوني",
  "report.reason.self_harm": "إيذاء النفس",
  "report.reason.child_safety": "سلامة الأطفال",
  "report.reason.spam": "محتوى مزعج",
  "report.reason.copyright": "حقوق النشر",
  "report.reason.other": "سبب آخر",

  "profile.joined": "انضم في {date}",
  "profile.videos": "المقاطع",
  "profile.views": "المشاهدات",
  "profile.likes": "الإعجابات",
  "profile.edit": "تعديل الملف",
  "profile.bio": "نبذة",
  "profile.avatar": "رابط الصورة",
  "profile.empty": "لا توجد مقاطع منشورة بعد.",
  "profile.tabVideos": "Videos",
  "profile.tabJoinedCommunities": "Joined Communities",
  "profile.tabCreatedCommunities": "Created Communities",
  "profile.noJoinedCommunities": "You have not joined any communities yet.",
  "profile.noJoinedCommunitiesOther": "This user has not joined any communities yet.",
  "profile.noCreatedCommunities": "You have not created any communities yet.",
  "profile.noCreatedCommunitiesOther": "This user has not created any communities yet.",
  "profile.exploreCommunities": "Explore Communities",
  "profile.createCommunity": "Create Community",
  "profile.manageMembers": "Manage Members",
  "profile.pendingRequestsCount": "{count} pending request(s)",
  "profile.browseFeed": "Browse Feed",

  "admin.title": "Admin Dashboard",
  "admin.subtitle": "Platform governance, user management, and moderation.",
  "admin.tabOverview": "Overview",
  "admin.tabUsers": "Users",
  "admin.tabCommunities": "Communities",
  "admin.tabModeration": "Moderation Queue",
  "admin.totalStorage": "Total Storage Used",
  "admin.totalUsers": "Total Users",
  "admin.activeUsers": "Active Users",
  "admin.totalVideos": "Total Videos",
  "admin.totalCommunities": "Total Communities",
  "admin.searchUsers": "Search users by username or email...",
  "admin.searchCommunities": "Search communities by name or slug...",
  "admin.user": "User",
  "admin.email": "Email",
  "admin.joined": "Joined",
  "admin.videosCount": "Videos",
  "admin.storageUsed": "Storage Used",
  "admin.status": "Status",
  "admin.role": "Role",
  "admin.active": "Active",
  "admin.banned": "Banned",
  "admin.administrator": "Admin",
  "admin.standardUser": "User",
  "admin.banUser": "Ban User",
  "admin.unbanUser": "Unban User",
  "admin.makeAdmin": "Make Admin",
  "admin.removeAdmin": "Remove Admin",
  "admin.confirmBan": "Are you sure you want to ban @{username}? Their active sessions will be terminated immediately.",
  "admin.confirmUnban": "Are you sure you want to reactivate @{username}?",
  "admin.confirmDeleteCommunity": "Are you sure you want to delete community \"{name}\"? Any existing videos will be safely moved to the default public community.",
  "admin.communityName": "Community",
  "admin.accessType": "Access Type",
  "admin.createdBy": "Created By",
  "admin.members": "Members",
  "admin.actions": "Actions",
  "admin.delete": "Delete",
  "admin.noUsersFound": "No users found.",
  "admin.noCommunitiesFound": "No communities found.",
  "admin.userUpdated": "User updated successfully.",
  "admin.communityDeleted": "Community deleted successfully.",
  "admin.queueDepth": "في الطابور",
  "admin.clear": "مُجازة",
  "admin.flagged": "موقوفة",
  "admin.blocked": "محجوبة",
  "admin.openReports": "بلاغات مفتوحة",
  "admin.approve": "قبول",
  "admin.reject": "رفض",
  "admin.reason": "السبب الظاهر لصاحب المقطع",
  "admin.notes": "ملاحظات داخلية",
  "admin.empty": "الطابور فارغ، لا يوجد ما يُراجع.",
  "admin.frames": "إطارات مأخوذة",
  "admin.noFrames": "لم تُؤخذ أي إطارات.",
  "admin.provider": "المزود",
  "admin.score": "الدرجة",
  "admin.label": "التصنيف الأعلى",
  "admin.owner": "المالك",
  "admin.reports": "البلاغات",
  "admin.reviewed": "{action} — {status}",
  "admin.shortcuts": "اختصارات: J و K للتنقل، A للقبول، R للرفض.",
  "admin.forbidden": "هذه المنطقة مخصصة للمشرفين.",

  "error.generic": "حدث خطأ ما.",
  "error.network": "لا يمكن الوصول إلى الواجهة البرمجية. تأكد من تشغيل الخادم.",
  "error.rateLimited": "طلبات كثيرة جدًا. أعد المحاولة بعد {seconds} ثانية.",
  "error.notFound": "غير موجود.",
  "error.forbidden": "لا تملك صلاحية الوصول.",
  "error.unauthorized": "يرجى تسجيل الدخول مرة أخرى.",

  "community.all": "All",
  "community.tabs": "Communities",
  "community.create": "Create Community",
  "community.new": "New Community",
  "community.name": "Community Name",
  "community.namePlaceholder": "e.g. Doctors, Architects, Cairo",
  "community.nameHint": "Up to 60 characters",
  "community.description": "Description",
  "community.descriptionPlaceholder": "What is this community about?",
  "community.created": "Community created successfully.",
  "community.select": "Community",
  "community.selectHint": "Choose which community this video belongs to.",
  "community.empty": "No videos in this community yet.",
  "community.emptyHint": "Be the first to post a video in this community!",

  "search.title": "Search",
  "search.tabVideos": "Videos",
  "search.tabCommunities": "Communities",
  "search.placeholder": "Search videos by title, description, or @creator...",
  "search.communitiesPlaceholder": "Search communities by name or description...",
  "search.uploadDate": "Upload Date",
  "search.from": "From Date",
  "search.to": "To Date",
  "search.allDates": "Any Time",
  "search.sort": "Sort By",
  "search.sort.latest": "Newest Upload",
  "search.sort.oldest": "Oldest Upload",
  "search.sort.popular": "Most Popular",
  "search.results": "Search Results",
  "search.noResults": "No videos found.",
  "search.noResultsHint": "Try searching with different keywords or date filters.",
  "search.noCommunities": "No communities found.",
  "search.noCommunitiesHint": "Try searching with different keywords.",
  "search.browseCommunity": "Browse",
  "search.videoCount": "videos",
  "search.allCommunities": "All Communities",
  "search.clear": "Clear Search",

  "video.audience": "Audience",
  "video.audience.public": "Public",
  "video.audience.publicHint": "Anyone, signed in or not, can watch.",
  "video.audience.private": "Private",
  "video.audience.privateHint": "Only you can watch.",
  "video.audience.restricted": "Restricted",
  "video.audience.restrictedHint": "Only specific users you add can watch.",
  "video.allowedUsers": "Allowed Usernames",
  "video.allowedUsersHint": "Comma-separated list of usernames who may watch.",
  "video.allowedUsersRequired": "Please specify at least one username for restricted audience.",
  "video.community": "Community",

  "community.privacy": "Community Privacy",
  "community.access.public": "Public",
  "community.access.publicHint": "Anyone, signed in or not, can browse and watch videos.",
  "community.access.private": "Private",
  "community.access.privateHint": "Only you can see this community and its videos.",
  "community.access.restricted": "Restricted",
  "community.access.restrictedHint": "Only approved members can watch videos. Users can request to join.",
  "community.initialMembers": "Initial Members (Optional)",
  "community.initialMembersHint": "Comma-separated usernames to add immediately.",
  "community.joinRequest": "Request to Join",
  "community.joinRequested": "Join Request Pending",
  "community.member": "Member",
  "community.owner": "Owner",
  "community.manageMembers": "Manage Members",
  "community.pendingRequests": "Pending Requests",
  "community.membersList": "Members List",
  "community.addMember": "Add Member",
  "community.addMemberPlaceholder": "Enter username to add...",
  "community.add": "Add",
  "community.remove": "Remove",
  "community.kickOff": "Kick off",
  "community.memberRemoved": "Member has been removed from this community.",
  "community.approve": "Approve",
  "community.reject": "Reject",
  "community.restrictedBanner": "This community is restricted to approved members.",
  "community.restrictedPrompt": "Request to join to view videos published in this community.",

  "feed.comments": "Comments",
  "comments.title": "Comments",
  "comments.placeholder": "Write a comment...",
  "comments.submit": "Post",
  "comments.posting": "Posting...",
  "comments.empty": "No comments yet. Be the first to comment!",
  "comments.guestHint": "Sign in to leave a comment.",
  "comments.delete": "Delete comment",
  "comments.deleteConfirm": "Are you sure you want to delete this comment?",
  "comments.count": "comments",
  "comments.loadMore": "Load more comments",
};
